export default __webpack_public_path__ + "static/atila_bw-e130dc790383498c57eb0437d6dd9b9d.jpg";